import { Directive, Injector, } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { UntypedFormGroup } from '@angular/forms';
import { ApAlertService, ApComplexModal, ApNotificationService } from 'webcommon/core-ui';
import { IColumnPk } from 'webcommon/shared';
import { FcItemModalContext, FcItemModalMode } from '../../models/FcItemModalContext';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class FcItemModalBaseComponent extends ApComplexModal<IColumnPk> {

  public fcModalItemContext: FcItemModalContext;

  fcItemFormGroup = new UntypedFormGroup({});
  isLoading = false;
  isSaving = false;

  constructor(
    elementInjector: Injector,
    public apNotificationService: ApNotificationService,
    public alertService: ApAlertService,
  ) {
    super(elementInjector);
  }

  onClose(result: IColumnPk) {
    const action = (this.fcModalItemContext.mode === FcItemModalMode.Modify) ? 'updated' : 'created';
    const successMessage = this.fcModalItemContext.findControlName + ' has been ' +
    action + '.';
    this.apNotificationService.success(successMessage);
    this.apClose(result);
  }

  onCancel() {
    super.apUserCancel();
  }
}
